import { render, staticRenderFns } from "./ProximityDialog.vue?vue&type=template&id=247905ca&"
import script from "./ProximityDialog.vue?vue&type=script&lang=js&"
export * from "./ProximityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports